import {FORM_VALID_MESSAGE, PHONES_PREFIX_FORE, PHONES_PREFIX_THREE} from "./constant";

/**
 * @param param { [key:string]:any}
 * @param url {string}
 * @return {string}
 */
export const addQueryToUrl = function(param, url) {
  if (!url) return "";
  if (!param || !Object.keys(param).length) return url;
  let _url = url;
  // 有问号提出url并添加至obj，没问号用原url
  if (url.indexOf("?") > -1) {
    param = Object.assign(
      {},
      {
        ...param,
        ...getUrlQuery(url)
      }
    );
    _url = url.split("?")[0];
  }
  let result = "?";
  for (const key in param) {
    if (param[key] !== undefined && param[key] !== null) {
      result += `${key}=${param[key]}&`;
    }
  }
  // 去除最后一个& 并返回
  return `${_url}${result.slice(0, -1)}`;
};
// 用户名提示
export const validNameTips = (name) => {
  console.log('程序的。。。', name,/^[0-9a-zA-Z]{4,20}$/.test(name));
  if (name){
    return /^[0-9a-zA-Z]{4,20}$/.test(name) ? '' : 'Tên đăng nhập phải từ 4 -20 ký tự'
  } else {
    return 'Vui lòng nhập tên đăng nhập'
  }
}
// 密码提示
export const validPassword = (password) => {
  if (password){
    return /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(password) ? '' : 'Mật khẩu phải từ 6 đến 15 ký tự'
  } else {
    return 'Vui lòng nhập mật khẩu'
  }
}
// 重复密码提示
export const validRePassword = (password,rePassword) => {
  if (rePassword) {
    if (password !== rePassword){
      return 'Mật khẩu không trùng khớp'
    } else {
      validPassword(rePassword)
    }
  } else {
    return 'Vui lòng nhập lại mật khẩu';
  }
}
// 验证码提示
export const validCode = (code) => {
  return code ? '' : 'Mã xác minh không chính xác'
}
export function validPhone(value) {
  if (!/^\d{10,11}$/.test(value)) {
    return FORM_VALID_MESSAGE.phoneInvalid
  } else if (value.length === 10 && !PHONES_PREFIX_THREE.includes(value.substr(0, 3)) ||
    value.length === 11 && !PHONES_PREFIX_FORE.includes(value.substr(0, 4))) {
    return FORM_VALID_MESSAGE.phoneInvalid
  } else {
    return ''
  }
}


export const setCookie = (name, value) => {
    // 设置 cookie，有效期为 7 天
    const date = new Date();
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000); // 设置过期时间
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
        value
    )}; ${expires}; path=/`;
};

export function detectBrowser() {
  const userAgent = navigator.userAgent;
  if (
    userAgent.indexOf("Chrome") !== -1 &&
    userAgent.indexOf("Safari") !== -1 &&
    userAgent.indexOf("Edg") === -1
  ) {
    return "Google Chrome"; // Chrome
  } else if (userAgent.indexOf("Firefox") !== -1) {
    return "Mozilla Firefox"; // Firefox
  } else if (
      userAgent.indexOf("Safari") !== -1 &&
      userAgent.indexOf("Chrome") === -1 &&
      userAgent.indexOf("Edge") === -1
  ) {
      return "Apple Safari"; // Safari
  } else if (userAgent.indexOf("Edg") !== -1) {
      return "Microsoft Edge"; // Edge
  } else {
      return "Unknown browser"; // 其他浏览器...（可根据自己需要确定是否新增其他浏览器的判断）
  }
}


// WEBPACK FOOTER //
// ./src/utils/util.js